import script from "./EmptyCartState.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyCartState.vue?vue&type=script&setup=true&lang=js"

import "./EmptyCartState.vue?vue&type=style&index=0&id=66964e6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66964e6a"]])

export default __exports__